import React from 'react';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { logoutLoggedInEmployee } from 'actions/loggedInEmployee';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isExploringDemoSelector } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { StyledTypography, StyledButton } from 'styles/common';

import { StyledIcon } from 'constants/icons';

// By providing className as prop, this component becomes styleable
function HelloBar({ history, className = 'hellobarContainer' }) {
  const isExploringDemo = useSelector(isExploringDemoSelector);
  const dispatch = useDispatch();

  function onSignUpClick() {
    dispatch(
      logoutLoggedInEmployee()
      //   () => {
      //   // On Successful logout, take the user to signup page
      //   history.push(routes.emailRegister);
      // }
    );
  }

  function onContactUsClick() {
    dispatch(
      logoutLoggedInEmployee()
      //   () => {
      //   // On Successful logout, take the user to signup page
      //   window.location.href = MARKETING_SITE_CONTACT_US_ROUTE;
      // }
    );
  }

  if (!isExploringDemo) return null;
  // if a link doesn't have a meaningful href, it should be rendered using a button
  return (
    <Container className={className}>
      <StyledIcon color="white" size="tiny" rightGutter={1}>
        <InfoOutlinedIcon />
      </StyledIcon>
      <StyledTypography color="white">You are currently exploring Mesh Demo.</StyledTypography>
      <StyledButton
        leftGutter={1}
        size="small"
        component="button"
        variant="contained"
        color="primary"
        onClick={onSignUpClick}
      >
        Sign Up
      </StyledButton>
      <StyledTypography color="white" leftGutter={1} rightGutter={1}>
        or
      </StyledTypography>
      <StyledButton size="small" component="button" variant="contained" color="primary" onClick={onContactUsClick}>
        Contact Us
      </StyledButton>
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  width: 100%;
  z-index: 2;
  left: 0;
  top: 52px;
  background-color: ${(props) => props.theme.palette.primary.main};
  display: flex;
  justify-content: center;
  padding: 0.25rem 0;
  box-shadow: ${(props) => props.theme.shadows[1]};
  color: white;
  align-items: center;
`;

export default withRouter(HelloBar);
